import TextWidgetEditor from './TextWidgetEditor';

export default TextWidgetEditor;
